export default __webpack_public_path__ + "static/media/head04_en_pc.5a065b56.png";